// extracted by mini-css-extract-plugin
export default {"url":"sJ8R7GyhnDAlj8Ra_9U3"};